import { StatusFormatter } from '@components'

import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { isSupportedCountryId } from '../../../../utils/isSupportedCountryId'
import { vatDeclarationStatuses } from './consts/vatDeclarationStatuses'
import { VatDeclarationStatus } from './types/vatDeclarationStatus'

export const VatDeclarationStatusesInfo = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  const statusesByCountry: VatDeclarationStatus[] = useMemo(() => {
    return organization?.countryId && isSupportedCountryId(organization?.countryId)
      ? vatDeclarationStatuses[organization?.countryId]
      : []
  }, [organization?.countryId])

  return (
    <Flex gap={Spacing.S32}>
      {statusesByCountry.map(({ variant, translationKey }) => (
        <Flex key={variant} alignItems="center" gap={Spacing.S6}>
          <StatusFormatter variant={variant} />
          <Text colorVariant="secondary" variant="bodySM">
            {t(translationKey)}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}
